import React, { createContext, useContext, useMemo } from 'react'
import { createWebClient } from '@/services/ApolloClient'
import { useUser } from '@/services/UserService'
import { useLocale } from '@/utils/LocaleUtil'

interface WatchlistContextValue {
  client: ReturnType<typeof createWebClient>
  viewerProfileId?: string
}

const WatchlistContext = createContext<WatchlistContextValue | undefined>(undefined)

export const WatchlistProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { locale } = useLocale()
  const { userId } = useUser()
  // TODO: when web implements user profiles, use that profile id here instead.
  const viewerProfileId = userId ?? undefined

  const client = useMemo(() => {
    return createWebClient({ locale, viewerProfileId })
  }, [locale, viewerProfileId])

  const value = useMemo(() => ({ client, viewerProfileId }), [client, viewerProfileId])

  return <WatchlistContext.Provider value={value}>{children}</WatchlistContext.Provider>
}

export const useWatchlistContext = () => {
  const context = useContext(WatchlistContext)
  if (!context) {
    throw new Error('useWatchlistContext must be used within a WatchlistProvider')
  }
  return context
}
